import BillingAmountCalculations from "./BillingAmountCalculations";
import ServiceBenefitLimitManagement from "./ServiceBenefitLimitManagement";
import ShortStayUsageDays from "./ShortStayUsageDays";
import { Styled } from "./styled";
import UserBurdenCalculationTable from "./UserBurdenCalculationTable";
import { IProps } from "../ServiceDeliveryTicket";
import Decimal from "decimal.js";
import { useMemo } from "react";

const DetailedServiceProvisionStatement = ({
  itemService,
  nurseCareLevel,
  currentDate,
}: IProps) => {
  const { insurance_card, services_detail, profile, treatment_data } =
    itemService;

  const servicesDetailRows = services_detail?.map((service) => {
    return {
      homeCareSupportOfficeNameInsuranceCard:
        insurance_card?.home_care_support_office_name, //3
      businessNumberProfile: profile?.business_number, //4
      serviceNameServiceDetail: service.service_name, //5
      serviceCodeManualServiceDetail: service.service_code_manual || "", //5
      unitPriceServiceDetail: service.unit_price, //7
      quantityServiceDetail: service.quantity, //9
      subtotalServiceDetail: service.subtotal, //10
    };
  });

  const total = services_detail
    .reduce((sum, item) => sum.plus(item.subtotal), new Decimal(0))
    .toNumber();

  const unitPrice = profile?.rate_registration_nursing_care; //13
  const benefitLimitInsuranceCard = insurance_card?.benefit_limit; //15

  const totalServicesDetailRow = useMemo(() => {
    const totalCostCovered = new Decimal(total)
      .times(unitPrice || 0)
      .trunc()
      .toString(); //14

    const insuranceClaimAmount = new Decimal(totalCostCovered)
      .times(benefitLimitInsuranceCard || 0)
      .div(100)
      .trunc()
      .toString(); //16

    const userCopaymentCovered = new Decimal(totalCostCovered)
      .minus(insuranceClaimAmount)
      .toString(); //18

    return {
      homeCareSupportOfficeNameInsuranceCard:
        insurance_card?.home_care_support_office_name, //3
      businessNumberProfile: profile?.business_number, //4
      serviceNameServiceDetail: "訪問介護 合計", //5
      subtotalServiceDetail: total, //10
      categoryLimitWithinLimitUnits: total, //12
      unitPrice, //13
      totalCostCovered, //14
      benefitLimitInsuranceCard, //15
      insuranceClaimAmount, //16
      userCopaymentCovered, //18
    };
  }, [itemService]);

  const treatmentDataRows = treatment_data?.map((treatment) => {
    const subtotalServiceDetail = new Decimal(total)
      .times(treatment.rate)
      .div(100)
      .round()
      .toNumber(); //10
    const totalCostCovered = new Decimal(subtotalServiceDetail)
      .times(unitPrice || 0)
      .trunc()
      .toString(); //14
    const insuranceClaimAmount = new Decimal(totalCostCovered)
      .times(benefitLimitInsuranceCard || 0)
      .div(100)
      .trunc()
      .toString();
    const userCopaymentCovered = new Decimal(totalCostCovered)
      .minus(insuranceClaimAmount)
      .toString(); //18
    return {
      homeCareSupportOfficeNameInsuranceCard:
        insurance_card?.home_care_support_office_name, //3
      businessNumberProfile: profile?.business_number, //4
      serviceNameServiceDetail: `訪問介護${treatment.service_name || ""}`, //5
      serviceCodeManualServiceDetail: treatment.service_code_manual || "", //6
      subtotalServiceDetail: subtotalServiceDetail, //10
      categoryLimitWithinLimitUnits: subtotalServiceDetail, //12
      unitPrice, //13
      totalCostCovered, //14
      benefitLimitInsuranceCard, //15
      insuranceClaimAmount, //16
      userCopaymentCovered, //18
    };
  });

  return (
    <div className="">
      <Styled className=" bg-white h-full w-full">
        <UserBurdenCalculationTable
          nurseCareLevel={nurseCareLevel}
          itemService={itemService}
          servicesDetailRows={servicesDetailRows}
          totalServicesDetailRow={totalServicesDetailRow}
          treatmentDataRows={treatmentDataRows}
          currentDate={currentDate}
        />
        <div className=" flex justify-between items-end m-1 print:break-inside-avoid-page ml-4">
          <div>
            <ServiceBenefitLimitManagement />
            <ShortStayUsageDays />
          </div>
          <div className="mb-[6mm]">
            <BillingAmountCalculations
              itemService={itemService}
              totalServicesDetailRow={totalServicesDetailRow}
              treatmentDataRows={treatmentDataRows}
            />
          </div>
        </div>
      </Styled>
    </div>
  );
};

export default DetailedServiceProvisionStatement;
